import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { CLIENT, RETRY_WAIT_TIME, RETRIABLE_STATUS_CODES } from './constants.mjs';
import { formatErrorMessage, getErrorMessage } from './utilities.mjs';

function generateHttpFetch(_ref) {
  var clientLogger = _ref.clientLogger,
      _ref$customFetchApi = _ref.customFetchApi,
      customFetchApi = _ref$customFetchApi === void 0 ? fetch : _ref$customFetchApi,
      _ref$client = _ref.client,
      client = _ref$client === void 0 ? CLIENT : _ref$client,
      _ref$defaultRetryWait = _ref.defaultRetryWaitTime,
      defaultRetryWaitTime = _ref$defaultRetryWait === void 0 ? RETRY_WAIT_TIME : _ref$defaultRetryWait,
      _ref$retriableCodes = _ref.retriableCodes,
      retriableCodes = _ref$retriableCodes === void 0 ? RETRIABLE_STATUS_CODES : _ref$retriableCodes;

  var httpFetch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestParams, count, maxRetries) {
      var nextCount, maxTries, response, _response, retryAfter;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nextCount = count + 1;
              maxTries = maxRetries + 1;
              _context.prev = 2;
              _context.next = 5;
              return customFetchApi.apply(void 0, _toConsumableArray(requestParams));

            case 5:
              response = _context.sent;
              clientLogger({
                type: 'HTTP-Response',
                content: {
                  requestParams: requestParams,
                  response: response
                }
              });

              if (!(!response.ok && retriableCodes.includes(response.status) && nextCount <= maxTries)) {
                _context.next = 9;
                break;
              }

              throw new Error();

            case 9:
              return _context.abrupt("return", response);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);

              if (!(nextCount <= maxTries)) {
                _context.next = 20;
                break;
              }

              retryAfter = (_response = response) === null || _response === void 0 ? void 0 : _response.headers.get('Retry-After');
              _context.next = 18;
              return sleep(retryAfter ? parseInt(retryAfter, 10) : defaultRetryWaitTime);

            case 18:
              clientLogger({
                type: 'HTTP-Retry',
                content: {
                  requestParams: requestParams,
                  lastResponse: response,
                  retryAttempt: count,
                  maxRetries: maxRetries
                }
              });
              return _context.abrupt("return", httpFetch(requestParams, nextCount, maxRetries));

            case 20:
              throw new Error(formatErrorMessage("".concat(maxRetries > 0 ? "Attempted maximum number of ".concat(maxRetries, " network retries. Last message - ") : '').concat(getErrorMessage(_context.t0)), client));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    return function httpFetch(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  return httpFetch;
}

function sleep(_x4) {
  return _sleep.apply(this, arguments);
}

function _sleep() {
  _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(waitTime) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, waitTime);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _sleep.apply(this, arguments);
}

export { generateHttpFetch };